import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02313dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-track" }
const _hoisted_2 = { class: "t-container" }
const _hoisted_3 = { class: "aigame-track-title aigame-track-tips__bd" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 赛道信息 ")
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"aigame-track-tips\" data-v-02313dc6><div class=\"aigame-track-tips__hd\" data-v-02313dc6>注意事项：</div><div class=\"aigame-track-tips__bd\" data-v-02313dc6><div class=\"aigame-track-tips__raidus\" data-v-02313dc6></div><div class=\"aigame-track-tips__text\" data-v-02313dc6>请先登录，再选择赛道。</div></div></div>", 1)
const _hoisted_6 = { class: "aigame-track-list" }
const _hoisted_7 = { class: "aigame-track-item__title" }
const _hoisted_8 = { class: "aigame-track-item__subtitle" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "aigame-rank-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickDataGuide()))
        }, "数据查看指引")
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelInfo, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "aigame-track-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.orderMap.get(item.Order)), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.Title), 1),
            _createElementVNode("div", {
              class: "aigame-track-item__btn",
              onClick: ($event: any) => (_ctx.clickChannel(item.Id))
            }, "进入查看", 8, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ]))
}